(function () {
  'use strict';

  angular.module('app').component('billRelatedTransactions', billRelatedTransactions());

  function billRelatedTransactions() {
    return {
      bindings: {
        bill: '<',
        providerId: '<',
      },
      controller: BillRelatedTransactionsComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bills/components/bill-related-transactions/bill-related-transactions.component.html',
    };
  }

  BillRelatedTransactionsComponent.$inject = ['BillService', 'RelatedTransactionService'];

  function BillRelatedTransactionsComponent(BillService, RelatedTransactionService) {
    const vm = this;

    vm.$onInit = function () {
      getRelatedTransactions();
    };

    vm.selectTransaction = function (transaction, index) {
      vm.transactionSelected = transaction;
      transaction.show = !transaction.show;

      if (index !== undefined) {
        vm.indexSelected = index;
      }
    };

    vm.openRelatedTransactionModal = function (transaction) {
      RelatedTransactionService.openRelatedTransactionModal(transaction);
    };

    function getRelatedTransactions() {
      vm.loadingRelatedTransactions = true;
      BillService.getRelatedTransactions(vm.bill.id, vm.providerId).then(function (data) {
        vm.bookings = data.bookings;
        vm.bill = data.bill.bill;

        if (vm.bookings.length > 0) {
          vm.bookings.forEach((booking) => {
            booking.bill = angular.copy(vm.bill);
          });
        }

        vm.creditNotes = data.bill.data.creditNotes || [];
        vm.paymentProviders = data.bill.data.paymentProviders || [];

        vm.loadingRelatedTransactions = false;
      });
    }
  }
})();
